import React from "react";

interface SnipeStatusTabsProps {
    onActive?: () => void;
    onSniped?: () => void;
    onInactive?: () => void;
    activeOn?: boolean; // true = showing, false = hidden
    snipedOn?: boolean;
    inactiveOn?: boolean;
}

const SnipeStatusTabs: React.FC<SnipeStatusTabsProps> = ({
    onActive,
    onSniped,
    onInactive,
    activeOn = false,
    snipedOn = false,
    inactiveOn = true,
}) => (
    <div className="min-h-20 w-full sticky top-0  z-20 flex gap-2">
        <div className="card w-full flex-row h-fit flex gap-2 bg-card/50 rounded-full overflow-hidden  backdrop-blur-xl">
            {/* <div className="w-full h-fit flex gap-2 bg-input p-1 rounded-full"> */}
            <button
                className={
                    `assented px-4 h-10 rounded-full transition-colors ` + (activeOn ? "" : "bg-card text-gray-500")
                }
                onClick={onActive}
            >
                Active
            </button>
            <button
                className={
                    `assented px-4 h-10 rounded-full transition-colors ` + (snipedOn ? "" : "bg-card text-gray-500")
                }
                onClick={onSniped}
            >
                Sniped
            </button>
            <button
                className={
                    `assented px-4 h-10 rounded-full transition-colors ` + (inactiveOn ? "" : "bg-card text-gray-500")
                }
                onClick={onInactive}
            >
                Inactive
            </button>
            {/* </div> */}
        </div>
    </div>
);

export default SnipeStatusTabs;
